import { addMinutes, parseISO } from "date-fns";
import { formatInTimeZone, utcToZonedTime } from "date-fns-tz";

export const mergeClientAvailability = (
  ranges,
  newTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone
) => {
  if (ranges?.length > 0) {
    const slotsSet = new Set();

    ranges.forEach((range) => {
      let current = utcToZonedTime(parseISO(range.start), newTimezone);
      const end = utcToZonedTime(parseISO(range.end), newTimezone);
      const preferred = range.preferred;

      while (current.getTime() < end.getTime()) {
        const next = addMinutes(current, 15);
        const startStr = formatInTimeZone(current, newTimezone, "yyyy-MM-dd HH:mm:ss XXX");
        const nextStr = formatInTimeZone(next, newTimezone, "yyyy-MM-dd HH:mm:ss XXX");
        const slotIdentifier = `${startStr}|${nextStr}|${preferred}`;
        slotsSet.add(slotIdentifier);
        current = next;
      }
    });

    // Convert the set back to an array of slot objects
    const slotsArray = Array.from(slotsSet).map((slot) => {
      const [start, end, preferred] = slot.split("|");
      return {
        start,
        end,
        preferred: preferred === "true",
      };
    });

    // Sort the slots by start time in the new timezone
    slotsArray.sort((a, b) => new Date(a.start).getTime() - new Date(b.start).getTime());

    return slotsArray;
  } else {
    return [];
  }
};
